/* BP SITE — Global Interaction & Animation Script */
(function () {
  'use strict';

  /* ── Header: solidify on scroll ── */
  var header = document.querySelector('.header-wrapper');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('bp-scrolled', window.scrollY > 60);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Global scroll-reveal (.bp-reveal elements) ── */
  var reveals = document.querySelectorAll('.bp-reveal');
  if (reveals.length) {
    var revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var delay = e.target.dataset.revealDelay || 0;
          setTimeout(function () { e.target.classList.add('bp-in'); }, Number(delay));
          revealIO.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    reveals.forEach(function (el) { revealIO.observe(el); });
  }

  /* ── GemPages section entrance: Life Elements product rows ── */
  var lifeElRows = document.querySelectorAll(
    '.gps-512981278241326285 [data-id], ' +
    '.gps-512981278241391821 [class*="gp-grid"], ' +
    '.gps-512981278190994637 [class*="gp-grid"], ' +
    '.gps-611287950046528019 [class*="gp-grid"], ' +
    '.gps-611174377555231331 [class*="gp-grid"]'
  );
  if (lifeElRows.length) {
    var sectionIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.style.opacity = '1';
          e.target.style.transform = 'translateY(0)';
          sectionIO.unobserve(e.target);
        }
      });
    }, { threshold: 0.08 });
    lifeElRows.forEach(function (el) {
      if (!el.style.transition) {
        el.style.opacity = '0';
        el.style.transform = 'translateY(24px)';
        el.style.transition = 'opacity 0.7s ease, transform 0.7s cubic-bezier(.25,.46,.45,.94)';
      }
      sectionIO.observe(el);
    });
  }

  /* ── Testimonials: stagger cards ── */
  var testimonialSection = document.querySelector('.gps-582468712074838641');
  if (testimonialSection) {
    var cards = testimonialSection.querySelectorAll('[data-id]');
    var tIO = new IntersectionObserver(function (entries, ob) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var arr = Array.from(cards);
          arr.forEach(function (c, i) {
            setTimeout(function () {
              c.style.opacity = '1';
              c.style.transform = 'translateY(0) scale(1)';
            }, i * 100);
          });
          ob.disconnect();
        }
      });
    }, { threshold: 0.08 });
    cards.forEach(function (c) {
      c.style.opacity = '0';
      c.style.transform = 'translateY(28px) scale(0.97)';
      c.style.transition = 'opacity 0.6s ease, transform 0.6s cubic-bezier(.25,.46,.45,.94)';
    });
    tIO.observe(testimonialSection);
  }

  /* ── Global button ripple ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.button, .gp-button-base');
    if (!btn) return;
    var r    = btn.getBoundingClientRect();
    var size = Math.max(r.width, r.height);
    var rpl  = document.createElement('span');
    rpl.style.cssText = [
      'position:absolute', 'border-radius:50%', 'pointer-events:none',
      'background:rgba(255,255,255,0.25)',
      'width:' + size + 'px', 'height:' + size + 'px',
      'left:' + (e.clientX - r.left - size / 2) + 'px',
      'top:'  + (e.clientY - r.top  - size / 2) + 'px',
      'transform:scale(0)',
      'animation:bp-site-ripple 0.65s linear forwards',
      'z-index:999'
    ].join(';');
    if (getComputedStyle(btn).position === 'static') btn.style.position = 'relative';
    btn.appendChild(rpl);
    setTimeout(function () { rpl.remove(); }, 700);
  });

})();
